import axios from 'axios';
import powerBISettings from '../configs/powerBISettings.js';

const apiEndpoint = powerBISettings.tenantAdminServiceUrl;

export function deleteActiveUser(signInLog) {
  return axios.get(`${apiEndpoint}loginprerequisite/deleteHVAActiveUser/${signInLog}`);
}

export function validateLoginPrerequisite(signInLog) {
  return axios.get(`${apiEndpoint}loginprerequisite/validateloginprerequisite/${signInLog}`);
}

export function updateActiveUser(signInLog) {
  return axios.get(`${apiEndpoint}loginprerequisite/udpateactiveuser/${signInLog}`);
}

export function deletePreviousActiveUser(signInLog) {
  return axios.get(`${apiEndpoint}loginprerequisite/deleteprevioussession/${signInLog}`);
}

export function getTenantTimeout() {
   return axios.get(`${apiEndpoint}loginprerequisite/configurationinfo`);
}

export function getSHVA() {
  return axios.get(`${apiEndpoint}loginprerequisite/getSHVA`);
}